import React, { lazy } from 'react';
import { Quote } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'Laura M. & Max (Golden Retriever, 9 años)',
    text: "Pensé que los problemas articulares de Max eran 'cosas de la edad'. A los 10 días de aplicar el método, volvió a subir al sofá sin ayuda. Lloré de alegría al verlo correr de nuevo en el parque.",
    initials: 'LM',
    bg: '#B2AC88'
  }, {
    name: 'Carlos R. & Luna (Gata Siamesa, 5 años)',
    text: 'Luna sufría de problemas renales recurrentes. Desde que cambiamos su alimentación siguiendo la guía, sus últimos análisis salieron perfectos. El veterinario no lo podía creer.',
    initials: 'CR',
    bg: '#E2725B'
  }, {
    name: 'Ana P. & Rocky (Bulldog Francés, 3 años)',
    text: 'Las alergias en la piel de Rocky nos tenían desesperados (y gastando una fortuna en cremas). El Método Bio-Vital curó su piel desde adentro. Su pelaje ahora brilla como nunca.',
    initials: 'AP',
    bg: '#8E896D'
  }];
  return <section className="py-24 bg-cream" data-id="element-256">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-257">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-258">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-gray-900 mb-6" data-id="element-259">
            Cartas de amor de{' '}
            <span className="text-sage-dark italic" data-id="element-260">Pet Parents</span>
          </h2>
          <p className="text-lg text-gray-600" data-id="element-261">
            Historias reales de transformación que nos llenan el corazón.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-262">
          {testimonials.map((t, i) => <div key={i} className="bg-white rounded-3xl p-8 shadow-soft relative mt-8" data-id="element-263">
              <div className="absolute -top-8 left-1/2 transform -translate-x-1/2" data-id="element-264">
                <div className="w-16 h-16 rounded-full border-4 border-white shadow-md flex items-center justify-center text-white font-serif font-bold text-xl" style={{
              backgroundColor: t.bg
            }} aria-label={t.name} data-id="element-265">
                  {t.initials}
                </div>
              </div>

              <Quote className="w-8 h-8 text-sage-light/50 mx-auto mt-6 mb-4" data-id="element-266" />

              <p className="text-gray-700 text-center mb-6 italic leading-relaxed" data-id="element-267">
                "{t.text}"
              </p>

              <div className="text-center" data-id="element-268">
                <p className="font-bold text-gray-900 text-sm" data-id="element-269">{t.name}</p>
                <div className="flex justify-center mt-2 text-terracotta" data-id="element-270">
                  {[1, 2, 3, 4, 5].map(star => <svg key={star} className="w-4 h-4 fill-current" viewBox="0 0 20 20" data-id="element-271">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-272" />
                    </svg>)}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}